<template>
  <div v-if="visible" class="mensaje-flotante" :class="tipo">
    <button class="cerrar" @click="$emit('cerrar')">×</button>
    <p>{{ mensaje }}</p>
  </div>
</template>

<script setup lang="ts">
/**
 * Mensaje flotante de estado.
 *
 * Componente de presentación. Recibe sus datos por props o del store del módulo.
 */

import { watch, onBeforeUnmount } from 'vue'

const props = defineProps<{
  visible: boolean
  mensaje: string
  tipo: 'positivo' | 'error'
}>()

const emit = defineEmits<{ (e: 'cerrar'): void }>()

let timer: ReturnType<typeof setTimeout> | null = null

watch(() => props.visible, (val) => {
  if (timer) { clearTimeout(timer); timer = null }
  if (val) {
    timer = setTimeout(() => emit('cerrar'), 2500)
  }
})

onBeforeUnmount(() => { if (timer) clearTimeout(timer) })
</script>

<style scoped>
.mensaje-flotante {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  min-width: 300px;
  max-width: 500px;
  padding: var(--space-lg);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-lg);
  z-index: 2000;
  text-align: center;
  font-family: var(--font-family);
  animation: float-in 0.25s ease;
}

@keyframes float-in {
  from { opacity: 0; transform: translate(-50%, -50%) scale(0.95); }
  to { opacity: 1; transform: translate(-50%, -50%) scale(1); }
}

.mensaje-flotante.positivo {
  background: #d4edda;
  color: #155724;
}

.mensaje-flotante.error {
  background: #f8d7da;
  color: #721c24;
}

.cerrar {
  position: absolute;
  top: 8px;
  right: 12px;
  background: transparent;
  border: none;
  font-size: 1.2rem;
  font-weight: 600;
  cursor: pointer;
  color: inherit;
}
</style>
